<div class="deregister-form" *ngIf="kkmForm">
  <div class="ui-kit-layout-columns-2">
    <label for="title" translate data-qa="kkm-name-title">kkm.registration.name.input</label>
    <span id="title" data-qa="kkm-name">{{ kkmForm?.kkmInternalName }}</span>
  </div>
  <div class="ui-kit-layout-columns-2">
    <label for="model" translate data-qa="kkm-model-title">kkm.settings.model</label>
    <span id="model" data-qa="kkm-model">{{ kkmForm?.kkmModel }}</span>
  </div>
  <div class="ui-kit-layout-columns-2">
    <label for="serialNumb" translate data-qa="kkm-serial-number-title"
      >kkm.settings.serial.factory.number</label
    >
    <span id="serialNumb" data-qa="kkm-serial-number">{{ kkmForm?.kkmSerialNumber }}</span>
  </div>
  <div class="ui-kit-layout-columns-2">
    <label for="year" translate data-qa="kkm-year-title">kkm.settings.year</label>
    <span id="year" data-qa="kkm-year">{{ kkmForm.kkmYear }}</span>
  </div>
  <div class="ui-kit-layout-columns-2">
    <label for="retailPlace" translate data-qa="retail-place-name-title"
      >kkm.settings.in.retail.place</label
    >
    <span id="retailPlace" data-qa="retail-place-name">{{ kkmForm?.retailPlaceTitle }}</span>
  </div>

  <div class="ui-kit-layout-columns-2 last" data-qa-select="deregister-reason">
    <label for="reason" class="required-marker" translate data-qa="label-text"
      >kkm.action.deregister.reason</label
    >
    <tax-dropdown-list
      id="reason"
      [data]="delReasons"
      (submittedData)="selectedDelReason($event)"
      data-qa="select"
    ></tax-dropdown-list>
  </div>

  <div class="ui-kit-layout-columns-2">
    <div></div>
    <div class="confirmation" data-qa-checkbox="confirm">
      <input id="confirm" type="checkbox" [(ngModel)]="isConfirmed" data-qa="checkbox" />
      <label for="confirm" translate data-qa="checkbox-label-text">kkm.action.confirmation</label>
    </div>
  </div>

  <div class="ui-kit-bottom-buttons-block">
    <button data-qa-button="go-back" class="back-button" (click)="back()">
      {{ 'group.back' | translate }}
    </button>
    <div>
      <button
        data-qa-button="go-to-sign"
        class="button_blue"
        [disabled]="!isFormValid()"
        (click)="continue()"
        translate
      >
        button.continue
      </button>
    </div>
  </div>
</div>
